module.exports = __webpack_public_path__ + "static/media/11.e2a762db.wav";